<div class="fx-row fx-wrap fx-align-center fx-gap">
  <span *ngFor="let item of items">
    <av-tag
      [tag]="item"
      [active]="true"
      (remove)="itemRemoved($event)"
    ></av-tag>
  </span>
  <input
    class="tag-input"
    type="text"
    avInput
    [placeholder]="placeholder"
    name="item-value"
    [(ngModel)]="newItemValue"
  />
  <button avButton ofType="icon" [color]="color()" size="xs" (click)="addItem(newItemValue)">
    <av-icon name="plus"></av-icon>
  </button>
</div>
